export type InputRestrictionTypes = "integer" | "noSpecialChars" | "sms"
import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
    selector: '[appInputRestriction]',
    standalone: true
})
export class InputRestrictionDirective {
    inputElement: ElementRef;

    @Input({ required: true, alias: "appInputRestriction" }) appInputRestriction: InputRestrictionTypes = "noSpecialChars";

    constructor(el: ElementRef) {
        this.inputElement = el;
    }

    readonly smsChars = /[a-z]|[A-Z]|[0-9]|[!,.,?,!,$,+,*,:,;,<,>,",',\/,#,%,,_,=,(,),\s]/

    @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
        if (this.appInputRestriction === 'sms') {
            this.smsOnlyChars(event)
        }

    }

    smsOnlyChars(event: KeyboardEvent) {
        if (!this.smsChars.test(event.key)) {
            event.preventDefault()
        }


    }



    @HostListener('paste', ['$event']) onPaste(event: any) {
        let regex;
        switch (this.appInputRestriction) {
            case "sms":
                regex = this.smsChars;
                break
            default:
                regex = new RegExp("")
        }

        const e = <ClipboardEvent>event;
        const pasteData = e.clipboardData?.getData('text/plain') ?? "";
        let m;
        let matches = 0;
        while ((m = regex.exec(pasteData)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            // The result can be accessed through the `m`-variable.
            m.forEach((match, groupIndex) => {
                matches++;
            });
        }
        if (matches === pasteData.length) {
            return;
        } else {
            e.preventDefault();
        }
    }

}